import CreateEmailModal from 'components/CreateEmailModal/CreateEmailModal';

export default CreateEmailModal;
